module.exports = __webpack_public_path__ + "media/images/icons/filled/folder-4f0482584b89f9ac8e6c0cb8da3ca70c.svg";